import AreaListSkeleton from './area-list-skeleton'
import PropertiesListSkeleton from './properties-list-skeleton'
import PropertiyGallerySkeleton from './property-gallery-skeleton'

export { PropertiyGallerySkeleton, AreaListSkeleton }

export default PropertiesListSkeleton
